import type { Override } from "@bbj-types/utils";
import CheckIcon from "@mui/icons-material/Check";
import { Chip, type ChipProps, Stack, Typography } from "@mui/material";
import { useDRPContext } from "../context";

const CustomChip = ({
  label,
  selected,
  ...props
}: Override<Omit<ChipProps, "color">, { label: string }> & {
  selected: boolean;
}) => (
  <Chip
    {...props}
    color={selected ? "primary" : undefined}
    label={
      selected ? (
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <CheckIcon fontSize="small" />
          <Typography>{label}</Typography>
        </Stack>
      ) : (
        label
      )
    }
  />
);

export const DRPChips = () => {
  const { selectedChip, handleChipChange, innerChips } = useDRPContext();

  if (!innerChips || innerChips.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        px: 2,
        overflow: "auto",
      }}
    >
      <CustomChip label="Dates exactes" onClick={() => handleChipChange(null)} selected={selectedChip === null} />
      {innerChips?.map((chip) => (
        <CustomChip
          key={chip.value}
          label={chip.label}
          onClick={() => handleChipChange(chip)}
          selected={selectedChip?.value === chip.value}
        />
      ))}
    </Stack>
  );
};
